import { StreetSearchResult } from '@models/address.model';

export function getStreetDescription(city: StreetSearchResult): string {
  return city?.Present;
}
